__turbopack_context__.v({
  "actions": "siteError-module__Ih95WG__actions",
  "content": "siteError-module__Ih95WG__content",
  "header": "siteError-module__Ih95WG__header",
  "page": "siteError-module__Ih95WG__page",
  "panel": "siteError-module__Ih95WG__panel",
});
